import React, {useState} from 'react'
import {AppBar, Toolbar, Avatar,Button, Tabs, Tab, useMediaQuery, useTheme, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField } from '@mui/material';
import HideOnScroll from "./HideOnScroll";
import DrawerComp from './Drawer';
import { Link } from 'react-router-dom';
import img from '../assests/tranparentlogo.png'

const Header = (props) => {

    const [value, setValue] = useState();
    const [open, setOpen] = useState(false);
    const [subscribe, setSubscribe] = useState({name: '', email: ''})
    const theme = useTheme();
    const isMatch = useMediaQuery(theme.breakpoints.down("md"));
    const pages = props.pages
    const backend = 'https://oureclecticsociety.org/core'

    const handleSubmit = (e) => {
        e.preventDefault()
    
        if(subscribe){
    
          fetch(`${backend}/subscriber-create/`, {
            method : 'POST',
            headers : {"Content-type": "application/json"},
            body: JSON.stringify(subscribe)
          })
    
        }
        else{
          setOpen(true)
        }
        setOpen(false)
        window.location.reload()
         
      }

  return (
    <React.Fragment>
        <HideOnScroll threshold={400}>
            <AppBar sx={{ background: '#063970' }}>
                <Toolbar>
                    <Avatar alt="logo" src={img} sx={{ width: 150, height: 120 }} variant="square" />

                    { isMatch ? 
                        (
                            <DrawerComp pages={pages} />
                        ) : 
                        (
                            <>
                                <Tabs sx={{marginLeft: 'auto'}} textColor='inherit' value={value} onChange={ (e, value) => setValue(value) } indicatorColor="secondary">
                                    { pages.map((page, index) => (
                                        <Tab key={index} label={page.text} component={ Link } to={page.path} />
                                    ))}
                                    <Button variant='contained' color='error' sx={{ borderRadius: 10 }} onClick={ ()=> setOpen(!open)}>Subscribe</Button>               
                                </Tabs>
                            </>
                        ) 
                    } 
                </Toolbar>  
            </AppBar>
        </HideOnScroll>

        <Dialog  open={open} onClose={ ()=> setOpen(false) }>
            <DialogTitle>SUBSCRIBE!</DialogTitle>
            <DialogContent>
                <DialogContentText>Subscribe so you can join our community of open discussions on matters that affect US</DialogContentText>
                <form>
                    <TextField sx={{mb:2}} onChange={(e) => setSubscribe({...subscribe, name: e.target.value}) } label="Enter name..." variant="outlined" fullWidth/>
                    <TextField onChange={(e) => setSubscribe({...subscribe, email: e.target.value}) } label="Enter email..." variant="outlined" fullWidth/>
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={ ()=> setOpen(!open)} >Cancel </Button>
                <Button onClick={ handleSubmit } >Submit</Button>
            </DialogActions>
        </Dialog>
        
    </React.Fragment>
    
  )
}

export default Header
